import {SimStats} from "./SimStats";
import {SimRunes} from "./CalculationObjects";
import {SimPlayerInfo} from "./SimPlayerInfo";
import SimChampion from "./SimChampion";
import {SimSkillOrder} from "./SkillOrder";
import SimItem from "../ItemInfo";
import Player from "../Player";
import RiotDB from "../RiotDB";

export default class SimPlayer{

	level:number;
	runes:SimRunes;
	champ:SimChampion;
	skillOrder:SimSkillOrder;
	items:SimItem[] = [];


	constructor(level,champ:SimChampion,skillOrder:SimSkillOrder, runes:SimRunes){
		this.level = level;
		this.champ = champ;
		this.skillOrder = skillOrder;
		this.runes = runes;
	}

	static createFromPlayer(player:Player, level:number):SimPlayer{
		let selectedRunes:any = player.selectedRunes;
		let selectedSkillOrder:any = player.selectedSkillOrder;
		if (selectedRunes == undefined){
			selectedRunes = null;
		}
		else{
			selectedRunes = player.selectedRunes.runes;
		}
		if (selectedSkillOrder == undefined){
			selectedSkillOrder = null;
		}
		else{
			selectedSkillOrder = player.selectedSkillOrder;
		}
		return new SimPlayer(level, new SimChampion(RiotDB.getChampionJSON(player.selectedChampion).stats), selectedSkillOrder, selectedRunes);
	}


	addItem(item:SimItem){
		this.items.push(item);
	}


	getRankForAbility(key:string){
		if ('AAPDM'.indexOf(key) != -1){
			return 1;
		}

		if('QWER'.indexOf(key) == -1) throw new Error("you must enter Q,W,E,R to calculate ability rank");

		let rank = 0;
		for(let i = 1; i <= this.level; i++){
			if(this.skillOrder.order[i-1] == key){
				rank++;
			}
		}

		return rank;
	}

	getInfo():SimPlayerInfo{
		let ret = new SimPlayerInfo();

		ret.level = this.level;

		for (let i = 0; i < SimStats.BSTATS.length; i++) {
			let statName = SimStats.BSTATS[i];

			ret[statName] = 0;
			ret[statName + "_B"] = 0;
			ret[statName + "_PL"] = 0;

			this.addStatToBase(statName,this.champ,ret);
			this.addStat(statName,this.champ,ret);
			if (this.runes != null){
				this.addStat(statName,this.runes,ret);
			}


			for (let j = 0; j < this.items.length; j++) {
				let item = this.items[j];
				this.addStat(statName,item,ret);
			}

		}

		//TODO find a better solution
		ret.curHealth = ret.H * .5;


		return ret;
	}

	addStatToBase(statName,from:SimStats,to:SimStats){
		this._addStat(statName + "_B",statName,from,to);
	}

	addStat(statName,from:SimStats,to:SimStats){
		this._addStat(statName,statName,from,to);
	}

	_addStat(destName:string,sourceName:string,source,target){
		let plStatName = sourceName +"_PL";
		let total = 0;

		if(source[sourceName] != undefined){
			total += source[sourceName];
		}
		if(source[plStatName] != undefined){
			total += source[plStatName] * (this.level-1);
		}

		target[destName] += total;

		return total;
	}



}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/fbobjects/calculation/SimPlayer.ts